/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { $ } from '../other/jquery-hooked.js';


var _mj_prg_dly_el = null;
var _mj_prg_dly_iv = null;
function _mj_prg_dly_elems() {
	return _mj_prg_dly_el===null ? (_mj_prg_dly_el=$('#page-dim-overlay,#progress')) : _mj_prg_dly_el;
}

function _mj_prg_dly_reset() {
	if( _mj_prg_dly_iv!==null ) {
		clearInterval(_mj_prg_dly_iv);
		_mj_prg_dly_iv = null;
	}
}

function _mj_prg_dly() {
	_mj_prg_dly_elems().show();
	_mj_prg_dly_reset();
}

export function startProgress( imm, iv ) {
	if( _mj_prg_dly_iv!==null ) return;
	if( imm ) _mj_prg_dly();
	else _mj_prg_dly_iv = setInterval(_mj_prg_dly,iv||350);
}

export function stopProgress() {
	_mj_prg_dly_reset();
	_mj_prg_dly_elems().hide();
}


// compat ..
window.startProgress = startProgress;
window.stopProgress = stopProgress;
